import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { useMutation } from "@tanstack/react-query";

export default function useSendWizardResultMutation() {
    return useMutation({
        mutationFn: salesApiService.onboarding.sendWizardResult,
        retry: false,
    });
}
